var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMastercard(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FF5F00",
    d: "M8.667 2.889H14.667V13.556H8.667z",
    transform: "translate(-32 -170) translate(16 152) translate(16 18.5) translate(4 7.5)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#EB001B",
    d: "M9.482 8.221c-.002-2.045.927-3.978 2.518-5.24-2.703-2.148-6.585-1.836-8.917.718-2.333 2.554-2.333 6.492 0 9.046 2.332 2.554 6.214 2.867 8.917.719-1.592-1.263-2.52-3.197-2.518-5.243z",
    transform: "translate(-32 -170) translate(16 152) translate(16 18.5) translate(4 7.5)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F79E1B",
    d: "M22.667 8.223c0 2.552-1.442 4.88-3.712 5.996-2.27 1.115-4.97.822-6.955-.756 1.59-1.264 2.519-3.196 2.519-5.24 0-2.046-.929-3.978-2.519-5.242 1.984-1.577 4.685-1.87 6.955-.755 2.27 1.115 3.712 3.443 3.712 5.995v.002z",
    transform: "translate(-32 -170) translate(16 152) translate(16 18.5) translate(4 7.5)"
  }))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMastercard);
export default __webpack_public_path__ + "static/media/mastercard.15dcf057.svg";
export { ForwardRef as ReactComponent };